var _require = require("../../../consts"),
  TR_BRANDS = _require.TR_BRANDS,
  SELFIE_FLOW_STATES = _require.SELFIE_FLOW_STATES,
  TR_STATES = _require.TR_STATES,
  ONSITE_FLOW_STATES = _require.ONSITE_FLOW_STATES,
  REGION = _require.REGION,
  BRAND = _require.BRAND;
var _require2 = require("../../../utils"),
  getApiBrand = _require2.getApiBrand;
var config = {
  "APP_URL": "https://czr.internalprod.americanwagering.com",
  "EXTERNAL_SB_API": "https://api.internalprod.americanwagering.com",
  "OPEN_BETS_POLL_INTERVAL": 10000,
  "ALL_OPEN_BETS_POLL_FREQUENCY": 3,
  "TETHERED_REG_GEO_POLL_INTERVAL": 30000,
  "DIFFUSION_LIVESCORES_SOCKET": function DIFFUSION_LIVESCORES_SOCKET(state, country, brand) {
    return "api.americanwagering.com/regions/".concat(country, "/locations/").concat(state, "/brands/").concat(getApiBrand(brand), "/livescores");
  },
  "DIFFUSION_BASE_URL": function DIFFUSION_BASE_URL(state, country, brand) {
    return "api.americanwagering.com/regions/".concat(country, "/locations/").concat(state, "/brands/").concat(getApiBrand(brand));
  },
  "DIFFUSION_CASHOUT_SOCKET": function DIFFUSION_CASHOUT_SOCKET(state, country, brand) {
    return "api.americanwagering.com/regions/".concat(country, "/locations/").concat(state, "/brands/").concat(getApiBrand(brand), "/cashout");
  },
  "PAM_URL": function PAM_URL(state) {
    return "https://api.americanwagering.com/pam/".concat(state === 'on' ? 'ca-on' : state, "/api");
  },
  "PAM_BASE_URL": function PAM_BASE_URL(state, country, brand) {
    return "https://api.americanwagering.com/regions/".concat(country, "/locations/").concat(state === 'on' ? 'ca-on' : state, "/brands/").concat(getApiBrand(brand), "/pam");
  },
  "GLOBAL_PAM_BASE_URL": "https://api.americanwagering.com/pam",
  "ACCOUNT_CLOSE_URL": "https://api.americanwagering.com/caesarscomms/account/close",
  "ALGOLIA_APP_ID": "MC1HI8TJZC",
  "ALGOLIA_API_KEY": "4350b86fb31421d29907e4454c7dad6c",
  //cms config
  "FEATURE_ANNOUNCEMENT_DATA": "https://eu-cdn.contentstack.com/v3/content_types/feature_anouncements/entries/bltb8588f3f0270a954?environment=website",
  "FEATURE_ANNOUNCEMENT_DATA_HEADERS": {
    "api_key": "bltacc3c964874661a8",
    "authorization": "cs6f764b1b6f71c31cf4d22d16"
  },
  "CMS_ROOT": "https://cdn.contentstack.io/v3/content_types/",
  "CMS_HEADERS": {
    "api_key": "blt07f2225743220ad0",
    "access_token": "cs70c41abda2a22aa4cb7d86d4"
  },
  "CMS_HEADERS_CASINO": {
    "api_key": "blt3ee0cc45db5e2f58",
    "access_token": "cs9c707cfdcd964646468222e5"
  },
  "CMS_PATH_STATUS_MESSAGE": "app_status_messaging/entries/bltb82d7078fae2addf?environment=website",
  "CMS_PATH_TETHERED_REG_LOCATIONS": function CMS_PATH_TETHERED_REG_LOCATIONS(state, country, brand) {
    if (state === REGION.PR) {
      return "tetheredreglocation/entries?environment=website&query={%22apps%22:%22".concat(BRAND.CZR_PR, "%22}");
    } else if (state === REGION["WA-MS"]) {
      return "tetheredreglocation/entries?environment=website&query={%22apps%22:%22".concat(BRAND.CZR_WA_MS, "%22}");
    } else if (state === REGION.NV && brand === BRAND.CZR) {
      return "tetheredreglocation/entries?environment=website&query={%22apps%22:%22".concat(BRAND.CZR_NV, "%22}");
    }
    return TR_BRANDS.includes(brand) ? "tetheredreglocation/entries?environment=website&query={%22apps%22:%22".concat(brand, "%22}") : '';
  },
  "CMS_PATH_TETHERED_ONSITE_COPY": "tethered_registration_onsite_copy/entries?environment=website",
  "CMS_PATH_CAESARS_REWARDS_EXPERIENCES": "czr_loyalty/entries/bltba7c4fcb9b7ff4c6?environment=website",
  "CMS_PATH_CAESARS_REWARDS_TIER_BENEFITS": "czr_loyalty_tier_benefits/entries/blt5442e2821e283ce9?environment=website",
  "CMS_PATH_CAESARS_REWARDS_FAQ": "czr_loyalty_faq/entries/blt0beaf1c08f55ce65?environment=website",
  "CMS_PATH_CAESARS_REWARDS_ASSETS": "czr_loyalty_assets/entries/blta40cf9bed426d721?environment=website",
  "CMS_PATH_V3_PROMOS": 'test/entries?environment=website',
  "CMS_PATH_REGISTRATION_CONFIG": 'registration_config/entries?environment=website',
  "CMS_PATH_TERMS_OF_SERVICE": 'terms_and_conditions/entries?environment=website',
  "CMS_PATH_REGISTRATION_COPY": 'registration_copy/entries?environment=website',
  "CMS_PATH_TOOLTIPS": "sportsbook_tooltip/entries?environment=website",
  "CMS_PATH_CASINO_CAMPAIGNS": "promotion_v1/entries?environment=website",
  "CMS_PATH_REFERRAL_TERMS": "raf_state_terms/entries?environment=website",
  "CONTENTSTACK_HELP_PAGES_URL": function CONTENTSTACK_HELP_PAGES_URL(state, country, brand) {
    return brand === BRAND.CZR_CASINO ? "https://www.caesarspalaceonline.com/".concat(state, "/support") : "https://www.caesars.com/sportsbook-and-casino/".concat(state, "/support");
  },
  "USE_CONTENTSTACK_HELP_PAGES": "true",
  "HELP_URL": "https://help.us.williamhill.com",
  "PTS_BASE_URL": function PTS_BASE_URL(state, country, brand) {
    return "https://api.americanwagering.com/regions/".concat(country, "/locations/").concat(state, "/brands/").concat(getApiBrand(brand), "/loyalty/transactions");
  },
  "LOYALTY_BASE_URL": function LOYALTY_BASE_URL(state, country, brand) {
    return "https://api.americanwagering.com/regions/".concat(country, "/locations/").concat(state, "/brands/").concat(getApiBrand(brand), "/loyalty");
  },
  "VORAX_URL": "https://vorax.us.williamhill.com/event",
  "VORAX_HEADERS": {
    "api_key": "RKlyPhneWcsbyT1zdShUqn3zr0R9hDcX"
  },
  "ALGOLIA_SEARCH_THROTTLE_TIME_IN_MS": 1500,
  "CASINO_CONTENT_STACK_LOBBY": function CASINO_CONTENT_STACK_LOBBY(state, country, brand) {
    return "https://api.internalprod.americanwagering.com/regions/".concat(country, "/locations/").concat(state, "/brands/").concat(getApiBrand(brand), "/igaming/igaming-platform/api/v1/").concat(state);
  },
  "CASINO_CONTENT_STACK_LOBBY_V2": function CASINO_CONTENT_STACK_LOBBY_V2(state, country, brand) {
    return "https://api.internalprod.americanwagering.com/regions/".concat(country, "/locations/").concat(state, "/brands/").concat(getApiBrand(brand), "/igaming/igaming-platform/api/v2/").concat(state);
  },
  "CASINO_CONTENT_STACK_BONUS": function CASINO_CONTENT_STACK_BONUS(state, country, brand) {
    return "https://api.internalprod.americanwagering.com/regions/".concat(country, "/locations/").concat(state, "/brands/").concat(getApiBrand(brand), "/igaming/bonus-engine/api/v1");
  },
  "CASINO_CONTENT_STACK_BONUS_V2": function CASINO_CONTENT_STACK_BONUS_V2(state, country, brand) {
    return "https://api.internalprod.americanwagering.com/regions/".concat(country, "/locations/").concat(state, "/brands/").concat(getApiBrand(brand), "/igaming/bonus-engine/api/v2");
  },
  "CASINO_NETENT_GAME_EVO_JACKPOT_API_URL": function CASINO_NETENT_GAME_EVO_JACKPOT_API_URL(state, country, brand) {
    return "https://api.internalprod.americanwagering.com/regions/".concat(country, "/locations/").concat(state, "/brands/").concat(getApiBrand(brand), "/igaming/igaming-platform/api/v1/jackpot");
  },
  "CASINO_NETENT_GAME_EVO_JACKPOT_SUPPLIER_API_GATEWAY": function CASINO_NETENT_GAME_EVO_JACKPOT_SUPPLIER_API_GATEWAY(state, country, brand) {
    return "https://api.internalprod.americanwagering.com/regions/".concat(country, "/locations/").concat(state, "/brands/").concat(getApiBrand(brand), "/igaming/suppliers-api-gateway/api/v1/jackpot");
  },
  "ALTERNATE_REFERENCE_LENGTH": 12,
  "WSOP_PROMO_URL": function WSOP_PROMO_URL(state) {
    return "https://www.wsop.com/promotions/sports-welcome-offer-vip/".concat(state, "/?sr=2720001&s=").concat(state);
  },
  "BACKGROUND_LIMIT_MINUTES": 240,
  "DEVICE_DATA_COLLECTOR_URL": "https://prod.dvc.americanwagering.com/cdn/cs/946a_pzupOvuG0GCeHptNa1M9MA.js",
  "AWS_WAF_URL": 'https://b470c5d1aeb4.edge.sdk.awswaf.com/b470c5d1aeb4/06faba802dee/challenge.js',
  "AWS_DOMAIN_LIST": ['.americanwagering.com', '.us.williamhill.com', '.sportsbook.caesars.com', '.caesarspalaceonline.com'],
  "AWS_CAPTCHA_URL": 'https://b470c5d1aeb4.edge.captcha-sdk.awswaf.com/b470c5d1aeb4/jsapi.js',
  "AWS_CAPTCHA_API_KEY": 'cFOe7NX/SsaVoz17jlLw7MJ+njexDW47PLjTjKqEps8yD0DAureKcPBYsbUjnBU4qfBIE2JLDf6+eY/WsqID8MO7rLvJdf/eQ93tLK12dQYyvjWSdeqLRV3qF3am48mNoATjK/9GQ5RnEe2BnZ0AvlOyKWtqxsJwmOPq9wmk+SjxnGWEVdxMMDTpQQobWl0Tp73PQyU9v0iO5iRBz+U7RsjEzV+h5ADIwvmxc4ARfqhJBQz/+eq1XeWYkjHkdkyNtm8ZbMx1eEEuGRDI8nxJVsUYuaL71JKRKwXXHdl7jVOJrAuQtivKyaB38MgjKdeS5bgF5N3kuTfoRYjG8LBzOMfgia3P0enKFiswytAA+mkts5zGIPf5zC8cC+Ib9t9/QZ/u+3iCDe+GE4IVpOt8loHEapSKjUAVQDgkabuqdfAv0fL93tdG5FQOQ4hYvuBfUjNTFue/E9FqZc98oRz2N4L5mA0X873zHbnBMvpU+xq1j/10WlqTXzMUfKeAiYTIkqMfoiFrCUER3oyHLQcIJNAfUcoXNsSiJM9LcgDrF0smRUigg+l4a/pm0dODyRzi8k25kVhdGjArki+j4keQhj17Ns99gsacaW0KkxPG7387FI7A/47V4RX3X15aMIDYBRVDSxJI/JENll2KaCumutvXFnm49KNphLzhtXAU3A4=_1_1',
  "TRANSACTION_HISTORY": function TRANSACTION_HISTORY(state, country, brand) {
    return "https://api.internalprod.americanwagering.com/regions/".concat(country, "/locations/").concat(state, "/brands/").concat(getApiBrand(brand), "/sb/v3/transaction-history");
  },
  "TAX_REPORT_W2G": function TAX_REPORT_W2G(state, country, brand) {
    return "https://api.internalprod.americanwagering.com/regions/".concat(country, "/locations/").concat(state, "/brands/").concat(getApiBrand(brand), "/igaming/transaction-history/api/v1/tax/report/");
  },
  "RAF_API_URL": "https://api.internalprod.americanwagering.com/rfp/api/v1",
  "KYC": "NEO",
  "KYC_POLL_INTERVAL": 30000,
  "TR_STATES": TR_STATES,
  "SELFIE_FLOW_STATES": SELFIE_FLOW_STATES,
  "ONSITE_FLOW_STATES": ONSITE_FLOW_STATES,
  "TRENDING_BETS_CONFIG": {
    "numberOfLegs": 4,
    "betTypes": 'BYO',
    "byEvent": {
      "numberOfLegs": 4,
      "betTypes": ['BYO'],
      "numberOfBets": 5,
      "sortBy": 'odds',
      "order": 'desc'
    },
    "makeItAParlay": {
      "numberOfLegs": 4,
      "betTypes": [],
      "numberOfBets": 4
    }
  },
  "NEW_RELIC": function NEW_RELIC(state, country, brand) {
    // Apps created with TF have state specific config for internalprod
    switch (brand) {
      // czr-casino-internalprod
      case 'czr-casino':
      case 'czr-casino-uat':
        return {
          accountID: "2619101",
          agentID: "594478069",
          applicationID: "594478069",
          licenseKey: "NRJS-d763eba5b69017b3966",
          trustKey: "2185826"
        };
      // horseshoe-internalprod
      case 'horseshoe':
        return {
          accountID: "2619101",
          agentID: "594477791",
          applicationID: "594477791",
          licenseKey: "NRJS-d763eba5b69017b3966",
          trustKey: "2185826"
        };
      // sportsbook-wh-internalprod
      case 'wh':
        return {
          accountID: "2619101",
          trustKey: "2185826",
          agentID: "594478079",
          licenseKey: "NRJS-d763eba5b69017b3966",
          applicationID: "594478079"
        };
      // All CZR apps reports to the same Internalprod application (sportsbook-czr-internalprod)
      case 'czr':
      case 'czr-pr':
      case 'czr-ms':
      case 'czr-wa-ms':
      case 'czr-uat':
        return {
          accountID: "2619101",
          agentID: "594478088",
          applicationID: "594478088",
          licenseKey: "NRJS-d763eba5b69017b3966",
          trustKey: "2185826"
        };
    }
  },
  "REGISTRATION_CONFIG": {
    "USE_THREAT_METRIX": false,
    "SHOW_RG_LIMITS": false,
    "USE_PROMO_APPLIED_BANNER": false,
    "USE_TERMS_OF_SERVICE_CHECKBOX": false,
    "DIRECT_MARKETING": false
  }
};
module.exports = config;